angular.module('avant.customer_applications.directives').directive 'avProgressBar', ->
  restrict: 'A'
  scope:
    avProgressBar: '@' # Ensure this value is ready on #link
  template: '''
    <div class="av-progress-bar__track">
      <div class="av-progress-bar__meter" ng-style="{ width: value + '%' }"></div>
    </div>
    <span class="av-progress-bar__label">{{value}}%</span>
  '''
  controller: ($scope) ->
    $scope.value = 0
  link: ($scope) ->
    if $scope.avProgressBar
      $scope.$on $scope.avProgressBar, (event, data) ->
        $scope.value = data.percent
